import { Injectable } from '@angular/core';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SharePointService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { CollectionState } from './collection-state';
import { ElementRiskAssessment } from 'src/app/models/domain';

@Injectable({ providedIn: 'root' })
export class ElementRiskAssessmentService {
  private readonly state = new CollectionState<ElementRiskAssessment>();

  public readonly elementRiskAssessments$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly sharePointService: SharePointService) {}

  public loadByCommunicationId(communicationId: string): Observable<void> {
    this.state.setLoading(true);

    return this.sharePointService.getElementRiskAssessmentsForCommunicationId(communicationId).pipe(
      tap((elementRiskAssessments) => {
        this.state.set(elementRiskAssessments);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }

  public reset() {
    this.state.reset();
  }
}
